import { defineStore } from "pinia";
import { ref, computed } from "vue";
import axios from "axios";
import { API_URL } from "@/utils/constans";
import { useRequestsStore } from "@/stores/storeRequests";
import { useSettingsStore } from "@/stores/storeSettings";
import { useGameHistory } from "@/composables/useGameHistory";
import { get } from "browser-cookies";

export const useQuizMatchesStore = defineStore("quizMatches", () => {
	const storeRequests = useRequestsStore();
	const storeSettings = useSettingsStore();
	const { getToken, saveGameData } = useGameHistory();

	const quizData = ref({});
	const isLoaderQuiz = ref(false);
	const isShowWelcomScreen = ref(true);
	const isShowGame = ref(false);
	const isShowEndGame = ref(false);
	const isShowResultGame = ref(false);
	const isShowErrorBanner = ref(false);
	const isGameMatchesSession = ref(false);

	const remainingTime = ref({ minutes: "00", secundes: "30" });
	const currentScore = ref(0);
	let intervalId;
	const status = computed(() => quizData.value?.gift_status );

	const isShowTimer = computed(() => {
		// данные ещё не пришли или пустые
		if(!quizData.value || Object.keys(quizData.value).length === 0) {
			// console.log('isShowTimer данные ещё не пришли или пустые:',);
			return false;
		}

		// скрыть при expired / none
		if (status.value === 'expired' || status.value === 'none' || status.value === 'claimed') {
			// console.log('isShowTimer скрыть при status expired / none / claimed',);
			return false;
		}
		// console.log('isShowTimer true', status.value);
		return true;
	});

	// const isShowGameStart = computed(() => {
	// 	// данные ещё не пришли или пустые
	// 	if(!quizData.value || Object.keys(quizData.value).length === 0) {
	// 		// console.log('isShowTimer данные ещё не пришли или пустые:',);
	// 		return false;
	// 	}

	// 	// скрыть при expired / none
	// 	if (status.value === 'approved') {
	// 		return false;
	// 	}
	// 	// console.log('isShowTimer true', status.value);
	// 	return true;
	// });

	const isMatchGameAvailable = computed(() => {
		if (!storeRequests.isAuthenticated && storeSettings.statusStockActive) {
			return true;
		}
		
		if(storeRequests.userData?.is_match_3_game_available  && storeSettings.statusStockActive){
			return true;
		}

		return false;
	});

	const isShowBanner = computed(() => {
		let gameAvailable = storeRequests.userData?.is_match_3_game_available;
		if (isShowTimer.value && storeSettings.statusStockActive) {
			gameAvailable = true;
		}
		if (gameAvailable) {
			return true
		} else {

			return false;
		}
	});

	const resetTimer = () => {
		clearInterval(intervalId);
		remainingTime.value = { minutes: "00", secundes: "30" };
	};

	const timer = () => {
		let totalSeconds = 30;
		intervalId = setInterval(() => {
			const minutes = Math.floor(totalSeconds / 60);
			const seconds = totalSeconds % 60;
			remainingTime.value.minutes = String(minutes).padStart(2, "0");
			remainingTime.value.secundes = String(seconds).padStart(2, "0");
			if (totalSeconds <= 0) {
				endGame();
			} else totalSeconds--;
		}, 1000);
	};

	const updateScore = (newScore) => {
		currentScore.value = newScore;
	};

	// API Methods
	const startGameMatch3 = async () => {
		try {
			const source = storeSettings.isTelegramPage ? "telegram" : "site";
			const { data } = await axios.post(`${API_URL}/api/match_3_game/match-three-game`, { source });
						
			if(!data.token) {
				isShowErrorBanner.value = true;
				return
			}

			if (!storeRequests.isAuthenticated) {
				saveGameData({
					token: data.token,
					gift_expires_at: data.gift_expires_at,
					is_timer_paused: false,
					remaining_seconds: false,
				});
			}
			return data;
		} catch (error) {
			console.log("startGameMatch3:", error);
			isShowErrorBanner.value = true;
		}
	};

	const endGameMatch3 = async (points, gameToken = null) => {
		try {
			// storeRequests.setAuthHeader();
			const params = { points };
			if (gameToken) {
				params.token = gameToken;
			}
			const { data } = await axios.put(`${API_URL}/api/match_3_game/match-three-game`, params);
			
			quizData.value = data;
			return data;
		} catch (error) {
			console.error("endGameMatch3:", error);
			throw error;
		}
	};

	const getGameMatch3 = async () => {
		try {
			storeRequests.setAuthHeader();
			
			const res = await axios.get(`${API_URL}/api/match_3_game/match-three-game`);
			
			if(res.status === 204) {
				isGameMatchesSession.value = true
			}
			quizData.value = res.data;
			return res.data;
		} catch (error) {
			console.error("getGameMatch3:", error);
			return null;
		}
	};

	const startGame = async () => {
		isShowErrorBanner.value = false;
		isLoaderQuiz.value = true;

		try {
			let gameData;

			// Для авторизованных: проверяем незавершённую игру
			if (storeRequests.isAuthenticated) {
				const existingGame = await getGameMatch3();

				if (existingGame && !existingGame.is_complete) {
					gameData = existingGame;
				}
			}

			// Если нет незавершённой игры — создаём новую
			if (!gameData) {
				gameData = await startGameMatch3();
			}

			// Проверяем токен — без него игра не может работать
			if (!gameData || !gameData.token) {
				return;
			}

			// Запускаем игру только после успешного ответа API
			currentScore.value = 0;
			quizData.value = gameData;
			isShowWelcomScreen.value = false;
			isShowGame.value = true;
			isShowEndGame.value = false;
			isShowResultGame.value = false;
			timer();
			window.scrollTo({ top: 0, behavior: "smooth" });

		} catch (err) {
			console.error(err);
		} finally {
			isLoaderQuiz.value = false;
			
		}
	};
	// const startGame = async () => {
	// 	currentScore.value = 0;
	// 	quizData.value = {};
	// 	isLoaderQuiz.value = true;
	// 	isShowWelcomScreen.value = false;
	// 	isShowGame.value = true;
	// 	isShowEndGame.value = false;
	// 	isShowResultGame.value = false;
	// 	timer();
	// 	window.scrollTo({ top: 0, behavior: "smooth" });

	// 	try {
	// 		const data = await startGameMatch3();
	// 		quizData.value = data;
	// 	} catch (err) {
	// 		console.error(err);
	// 	} finally {
	// 		isLoaderQuiz.value = false;
	// 	}
	// };

	const restartGame = () => {
		quizData.value = {};
		currentScore.value = 0;
		isShowWelcomScreen.value = true;
		isShowGame.value = false;
		isShowEndGame.value = false;
	};
	const resetGame = () => {
		// quizData.value = {};
		// currentScore.value = 0;
		isShowWelcomScreen.value = true;
		isShowGame.value = false;
		isShowEndGame.value = false;
	};

	const endGame = async () => {
		clearInterval(intervalId);
		isShowGame.value = false;
		isShowEndGame.value = true;

		try {
			const storedGameToken = getToken();

			const gameToken = storeRequests.isAuthenticated ? null : quizData.value?.token || storedGameToken;

			const data = await endGameMatch3(currentScore.value, gameToken);
			quizData.value = data;

			if (!storeRequests.isAuthenticated) {
				
				const localExpiresAt = Date.now() + 24 * 60 * 60 * 1000; 
				saveGameData({
					...data,
					gift_expires_at: new Date(localExpiresAt).toISOString(),
				});
			} 
		} catch (err) {
			console.log(err);
		}
	};

	return {
		startGame,
		restartGame,
		endGame,
		updateScore,
		startGameMatch3,
		endGameMatch3,
		getGameMatch3,
		resetGame,
		
		isLoaderQuiz,
		quizData,
		isShowWelcomScreen,
		isShowGame,
		isShowEndGame,
		isShowResultGame,
		timerActive: ref(true),
		remainingTime,
		currentScore,
		isShowTimer,
		isMatchGameAvailable,
		isShowBanner,
		isShowErrorBanner,
		isGameMatchesSession,
	};
});
